import { usePage } from "@inertiajs/react";
import { FunctionComponent } from "react";
import { Card, CardHeader } from "./ui/card";
import { Button } from "./ui/button";
import User from "@/types/generated/User";
import { toast } from "sonner";
import { Link2 } from "lucide-react";

const StatItem: FunctionComponent<{ title: string; count: number }> = ({
  title,
  count,
}) => {
  return (
    <div className="flex flex-col items-center text-center flex-1 px-2 border-r border-r-neutral-200 last:border-r-0 min-w-0">
      <span className="text-sm text-gray-600 mb-1 truncate w-full">
        {title}
      </span>
      <span className="font-bold font-ocr text-gray-900 truncate w-full">
        {count}
      </span>
    </div>
  );
};

export const ProfileNavigation: FunctionComponent = () => {
  const { auth } = usePage<{ auth?: { user: User } }>().props;

  if (!auth?.user) {
    return null;
  }

  const profileUrl = `${window.location.origin}/profile/${auth.user.slug}`;
  const profilePath = `/${auth.user.slug}`;

  function handleCopyUrl() {
    navigator.clipboard
      .writeText(profileUrl)
      .then(() => {
        toast.success("Profile URL copied to clipboard");
      })
      .catch(() => {
        toast.error("Failed to copy URL");
      });
  }

  return (
    <Card className="w-full bg-white min-w-0 rounded-3xl sticky top-28">
      <CardHeader className="flex flex-col gap-4 items-center min-w-0">
        <h2 className="font-bold text-gray-900 font-ocr w-full text-center overflow-hidden text-ellipsis whitespace-nowrap min-w-0">
          {auth.user.full_name}
        </h2>
        <div className="flex w-full gap-2 min-w-0">
          <StatItem title="Following" count={auth.user.following || 0} />
          <StatItem title="Followers" count={auth.user.followers || 0} />
          <StatItem title="Activities" count={auth.user.activities || 0} />
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleCopyUrl}
          className="w-full flex items-center gap-2 text-xs"
        >
          <Link2 className="h-3 w-3 flex-shrink-0" />
          <span className="truncate">{profilePath}</span>
        </Button>
      </CardHeader>
    </Card>
  );
};
